import { useEffect, useRef, useState } from 'preact/hooks';

import { getDurationInMilliseconds } from '../../../utils/datetime';

import { usePlayer } from './PlayerProvider';

const ONE_SECOND_IN_MILLISECONDS = getDurationInMilliseconds({ seconds: 1 });

const getTimeToStart = (
  serverTimeInMilliseconds: number,
  flightTimesStartInMilliseconds?: number
) => {
  return flightTimesStartInMilliseconds
    ? flightTimesStartInMilliseconds - serverTimeInMilliseconds
    : 0;
};

export const useTimeToStartCountdown = (
  flightTimesStartInMilliseconds?: number
) => {
  const player = usePlayer();
  const flightTimesStartRef = useRef(flightTimesStartInMilliseconds);
  const [isCountdownEnabled, setIsCountdownEnabled] = useState(true);
  const [timeToStart, setTimeToStart] = useState(() =>
    getTimeToStart(player.getServerTime(), flightTimesStartInMilliseconds)
  );

  useEffect(() => {
    if (!isCountdownEnabled) {
      return;
    }

    flightTimesStartRef.current = flightTimesStartInMilliseconds;

    const countdownHandler = () => {
      const newTimeToStart = getTimeToStart(
        player.getServerTime(),
        flightTimesStartInMilliseconds
      );

      setTimeToStart(newTimeToStart);

      if (newTimeToStart <= 0) {
        setIsCountdownEnabled(false);
      }
    };

    countdownHandler();

    const intervalId = window.setInterval(
      countdownHandler,
      ONE_SECOND_IN_MILLISECONDS
    );

    return () => window.clearInterval(intervalId);
  }, [isCountdownEnabled, flightTimesStartInMilliseconds, player]);

  useEffect(() => {
    if (flightTimesStartRef.current !== flightTimesStartInMilliseconds) {
      setIsCountdownEnabled(true);
    }
  }, [flightTimesStartInMilliseconds]);

  return {
    timeToStartInMilliseconds:
      // until countdown flow starts obtain time-to-start in a synchronous way
      flightTimesStartRef.current !== flightTimesStartInMilliseconds
        ? getTimeToStart(player.getServerTime(), flightTimesStartInMilliseconds)
        : timeToStart,
  };
};
